module.exports = __webpack_public_path__ + "img/0Q3A2365_P_L_BlackMatted.39a196c5.jpg";